import api from 'api';

const basePath = (establishmentSlug) => `establishments/${establishmentSlug}/inventory`;

export const getInventoryItems = async (establishmentSlug) => {
    const { data } = await api().get(basePath(establishmentSlug));
    return data;
};

export const createInventoryItem = async (establishmentSlug, payload) => {
    const { data } = await api().post(basePath(establishmentSlug), payload);
    return data;
};

export const updateInventoryItem = async (establishmentSlug, itemId, payload) => {
    const { data } = await api().put(`${basePath(establishmentSlug)}/${itemId}`, payload);
    return data;
};

export const deleteInventoryItem = async (establishmentSlug, itemId) => {
    const { data } = await api().delete(`${basePath(establishmentSlug)}/${itemId}`);
    return data;
};

export const createInventoryTransaction = async (establishmentSlug, itemId, payload) => {
    const { data } = await api().post(`${basePath(establishmentSlug)}/${itemId}/transactions`, payload);
    return data;
};

export const getInventoryStats = async (establishmentSlug) => {
    const { data } = await api().get(`${basePath(establishmentSlug)}/stats`);
    return data;
};

export const getInventoryItemTechSheets = async (establishmentSlug, itemId) => {
    const { data } = await api().get(`${basePath(establishmentSlug)}/${itemId}/tech-sheets`);
    return data;
};

export const syncInventoryItemTechSheets = async (establishmentSlug, itemId, techSheets) => {
    const { data } = await api().put(`${basePath(establishmentSlug)}/${itemId}/tech-sheets`, { tech_sheets: techSheets });
    return data;
};
